<div class="app_bg" [hidden]="isHidden">
  <div class="app_loader" >
    <img src = '/assets/images/icons/ajax_loader.gif'>
    <button class="btn__cancel" (click)="cancelRequests()">
      Cкасувати
    </button>
  </div>
</div>

<div class="dark-layer" [class.show]="!isHidden"></div>
